import React, { Suspense  } from 'react'
import { getDictionary } from '../dictionary'
import dynamic from 'next/dynamic'
import Section from './Section'
import Posts from './Posts'
import Tags from './Tags'
const Ad = dynamic(() => import('@/src/components/Ad'), { ssr: false })

interface GridTagsCompProps {
    tags?: any[],
    posts?: any[],
    tagName: string
}

export default function GridTagsComp({ tags, posts, tagName } : GridTagsCompProps) {
    return (
        <main id='main' className='md:pt-0'>
            <Suspense
                fallback={
                    (
                        <div className="flex flex-col gap-4 w-full pr-12 pb-12">
                            <div className="skeleton h-32 w-full"></div>
                            <div className="skeleton h-4 w-28"></div>
                            <div className="skeleton h-4 w-full"></div>
                            <div className="skeleton h-4 w-full"></div>
                        </div>
                    )}
            >
                <Section
                    key={getDictionary('postsName')}
                    title={`More from ${tagName}`}
                    showHeader={true}
                >
                    <Posts posts={posts} isEnd={true} setSize={() => null} size={0} isLoading={false} />
                </Section>
            </Suspense>
            <Section
                    key={'tags'}
                    title={`Tags`}
                    showHeader={true}
                >
                    <Tags tags={tags} />
                    <Ad id='side-tag' pos='anchor' closeButton={true} className={''} shouldAddNew category={undefined} postId={undefined} />
            </Section>
        </main>
    )
}
